import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionDetailsType } from "../../types/genericType";
import { formatDate } from "../../utils/dateFormat";
import { calculateDates } from "../../utils/utils";

type transactionDetailsState = {
  transactionDetails: Array<TransactionDetailsType>;
  selectedTransaction?: TransactionDetailsType;
  timeframe?: string;
  startFilterDate: string;
  endFilterDate: string;
};

const initialTransactionState: TransactionDetailsType = {
  id: 0,
  date: "",
  code: "Deposit",
  amount: 0.0,
  accountName: "",
  fromClientId: "",
  fromAccount: 0,
  account: 0,
  description: "",
  client: "",
  status: "",
  balance: 0,
  checkNumber: null,
  createdOn: "",
  bankTransactionType: undefined,
};

const currentDate = new Date();

const initialState: transactionDetailsState = {
  transactionDetails: [],
  selectedTransaction: initialTransactionState,
  timeframe: "0",
  startFilterDate: formatDate(
    new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
  ),
  endFilterDate: formatDate(currentDate),
};

export const transactionsSlice = createSlice({
  name: "transactionDetailsState",
  initialState,
  reducers: {
    setTransactionsDetailsState: (
      state,
      action: PayloadAction<TransactionDetailsType[]>
    ) => {
      state.transactionDetails = action.payload;
    },
    setSelectedTransaction: (
      state,
      action: PayloadAction<TransactionDetailsType>
    ) => {
      state.selectedTransaction = action.payload;
    },
    resetSelectedTransaction: (state) => {
      state.selectedTransaction = initialTransactionState;
    },
    updateTimeframe: (state, action: PayloadAction<string>) => {
      const values = calculateDates(action.payload);
      state.timeframe = action.payload;
      state.startFilterDate = values?.[0] ?? "";
      state.endFilterDate = values?.[1] ?? "";
    },
    updateDates: (state, action) => {
      state.startFilterDate = action.payload.startDate;
      state.endFilterDate = action.payload.endDate;
    },
  },
});

export const {
  setTransactionsDetailsState,
  setSelectedTransaction,
  resetSelectedTransaction,
  updateTimeframe,
  updateDates,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
